import {Input, Select} from "antd";
import {SelectForm} from "../SelectForm";
import React, {useState} from "react";
import {RecordForm} from "./RecordForm";
import {getFieldType} from "../../../../../../../utils/get-field-type";
import IconTriggerModal from "../../../Snippets/IconTriggerModal";

export const RowAction = ({type, value, onChange, onBlur, fieldName, fieldLabel}) => {

    const [fieldsValues, setFieldsValue] = useState([]);

    const getFirstOptionsFields = (fields) => {
        const fieldsValuesData = transformedFields(fields);
        setFieldsValue(fieldsValuesData)
    }

    const transformedFields = (fields) => {
        return [
            ...fields
                .filter(field => field.fieldtype !== 'formula' || field.isReadOnly)
                .map(field => ({
                    label: field.field,
                    value: field._id,
                    required: !!field.requiredField,
                    type: field.fieldtype,
                    typeText: getFieldType(field.fieldtype),
                    fieldProps: {
                        ...field
                    }
                })),
        ];
    }

    const onChangeRecordId = (e) => {
        handleChangeAll('recordId',e.target.value);
    }

    const onChangeExecuteRelatedTriggersOnThisAction = (valueChange) => {
        handleChangeAll('executeRelatedTriggersOnThisAction',valueChange)
    }

    const handleChangeAll = (prop,valueChange) => {
        const payload = {...value}
        payload[prop] = valueChange;
        if(prop === "form"){
            payload.fields = [];
        }
        if(!payload.recordId && type === "update"){
            payload.recordId = "";
        }
        if(!payload.form){
            payload.form = null;
        }
        if(!payload.fields){
            payload.fields  = [];
        }
        if(!payload.hasOwnProperty('executeRelatedTriggersOnThisAction')){
            payload.executeRelatedTriggersOnThisAction = true;
        }
        onChange(payload);
    }

    const handleChangeFormSelect = (valueChange) => {
        if (valueChange) {
            const {fields, id, name} = valueChange;
            const fieldsValuesData = transformedFields(fields);
            setFieldsValue(fieldsValuesData)
            handleChangeAll('form',{id, name})
        }
    }

    const executeRelatedTriggersOnThisAction = value && value.hasOwnProperty("executeRelatedTriggersOnThisAction") ? value.executeRelatedTriggersOnThisAction : true


    // Rótulo sempre acima do campo (.ae-label) e um bloco por linha: o painel é
    // estreito e a grade de 24 colunas com span 24 só criava recuos inúteis.
    return (<div>
        <div className="ae-field">
            <label className="ae-label">Formulário</label>
            <SelectForm
                onBlur={onBlur}
                withFields
                onChange={handleChangeFormSelect}
                value={value && value.form ? value.form : null}
                getFirstOptionsFields={getFirstOptionsFields}
            />
        </div>
        {(type === "update") ? (
            <div className="ae-field">
                <label className="ae-label">ID do registro</label>
                <Input
                    placeholder="{{ trigger._id }}"
                    value={value && value.recordId ? value.recordId : ""}
                    onChange={onChangeRecordId}
                    addonAfter={
                        <IconTriggerModal
                            fieldName={`${fieldName}.recordId`}
                            fieldLabel={"ID do Registro"}
                        />
                    }>
                </Input>
                <div className="ae-hint">Registro que será atualizado. Use o raio para inserir um valor do fluxo.</div>
            </div>
        ) : null}
        <RecordForm fields={fieldsValues || []} value={value} handleChangeAll={handleChangeAll}
                    disable={fieldsValues.length === 0} fieldName={fieldName}/>
        <div className="ae-field">
            <label className="ae-label">Acionar gatilhos do formulário</label>
            <Select
                onBlur={(e) => (onBlur) ? onBlur(e) : null}
                style={{width: '100%'}}
                value={executeRelatedTriggersOnThisAction}
                onChange={onChangeExecuteRelatedTriggersOnThisAction}
                options={[
                    {
                        label: "Sim",
                        value: true
                    },
                    {
                        label: "Não",
                        value: false
                    }
                ]}
            >
            </Select>
            <div className="ae-hint">
                Define se as automações atreladas a esse formulário rodam quando esta ação for executada.
            </div>
        </div>
    </div>)
}
